import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);

export const formatDepartureStartAndEndDates = (
    start: string | number | dayjs.Dayjs | Date | null | undefined,
    end: string | number | dayjs.Dayjs | Date | null | undefined,
    format = "MMM D",
) => {
    if (!start || !end) {
        return "";
    }
    const departureDate = dayjs.utc(start);
    const endDate = dayjs.utc(end);
    const fromFormat =
        departureDate.year() === endDate.year() ? format : `${format}, YYYY`;
    return `${departureDate.format(fromFormat)} – 
        ${endDate.format(`${format}, YYYY`)}`;
};
